import moment from 'moment';
export default function formattedDate(value, _fmt) {
  if (!value) {
    return '';
  }
  let fmt = _fmt || 'YYYY-MM-DD HH:mm:ss.S';
  return moment(value).format(fmt);
}